
    <ng-container>
        <div class="w-full py-3 flex align-items-center justify-content-between border-bottom-1 border-bottom-solid mb-3"
            [style]="{ 'border-color': 'var(--primary-gray)' }">
            <h2 class="text-xl font-semibold" data-clarity-unmask="true">Przydziel abonament</h2>
            <p-button icon="pi pi-times" [rounded]="true" [text]="true" size="small" (onClick)="closeDialog()" data-clarity-unmask="true"></p-button>
        </div>
    </ng-container>
    
    <section class="w-full flex flex-wrap md:flex-nowrap row-gap-2 p-3 border-bottom-1 border-bluegray-300">
        <p class="flex-none flex align-items-center w-12rem text-gray-500 font-normal text-sm">
          Kursant
        </p>
        <div class="flex-grow-1 flex flex-wrap align-items-center gap-2">
            {{data.studentDetails.displayName}}
        </div>
      </section>
    
        <app-subscription-selector 
        [(missingSubscriptionMessage)]="missingSubscriptionMessage"
        [(selectedSubscription)]="selectedSubscription"></app-subscription-selector>
    
    <div class="flex pt-4 justify-content-end gap-3">
        <p-button label="Anuluj" [outlined]="true" (onClick)="closeDialog()" [disabled]="loading" data-clarity-unmask="true"></p-button>
        <p-button label="Przydziel abonament" (onClick)="assignSubscription()" data-clarity-unmask="true" />
    </div>
